__turbopack_context__.v({
  "TabLinksVertical": "VOgnKW_TabLinksVertical",
  "TabLinksVertical--Expanded": "VOgnKW_TabLinksVertical--Expanded",
  "TabLinksVertical__Button": "VOgnKW_TabLinksVertical__Button",
  "TabLinksVertical__ButtonTag": "VOgnKW_TabLinksVertical__ButtonTag",
  "TabLinksVertical__ButtonText": "VOgnKW_TabLinksVertical__ButtonText",
  "TabLinksVertical__Container": "VOgnKW_TabLinksVertical__Container",
  "TabLinksVertical__Icon": "VOgnKW_TabLinksVertical__Icon",
  "TabLinksVertical__Line": "VOgnKW_TabLinksVertical__Line",
  "TabLinksVertical__PrimaryLink": "VOgnKW_TabLinksVertical__PrimaryLink",
  "TabLinksVertical__PrimaryLink--Active": "VOgnKW_TabLinksVertical__PrimaryLink--Active",
  "TabLinksVertical__PrimaryLinksContainer": "VOgnKW_TabLinksVertical__PrimaryLinksContainer",
  "TabLinksVertical__SecondaryLink": "VOgnKW_TabLinksVertical__SecondaryLink",
  "TabLinksVertical__SecondaryLinksContainer": "VOgnKW_TabLinksVertical__SecondaryLinksContainer",
});
